import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { CurrencyTaxLanguageSettings } from "components/settings/currency-tax-language-settings";
import {
  fetchLocalesAction,
  saveCurrencyLocaleTaxAction
} from "actions/account-settings-actions";
import { Loading } from "components/common/loading";

class CurrencyTaxLanguagePage extends React.Component {
  componentWillMount() {
    this.props.init(this.props.accountId);
  }

  render() {
    if (this.props.isLocalesLoading) {
      return <Loading />;
    }
    return (
      <CurrencyTaxLanguageSettings { ...this.props } />
    );
  }
}

CurrencyTaxLanguagePage.propTypes = {
  accountId: PropTypes.string.isRequired,
  init: PropTypes.func.isRequired,
  isLocalesLoading: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  currency: state.accountSettings.currency,
  currencies: state.currencies.currencies,
  isLocalesLoading: state.accountSettings.isLocalesLoading,
  locale: state.accountSettings.locale,
  showUniversalCategorySet: state.accountSettings.showUniversalCategorySet,
  supportedLocales: state.accountSettings.supportedLocales,
  vat: state.accountSettings.vat
});

const mapDispatchToProps = (dispatch) => ({
  init: (accountId) => dispatch(fetchLocalesAction(accountId)),
  onSaveCurrencyLocaleTax: () => dispatch(saveCurrencyLocaleTaxAction())
});

export const CurrencyTaxLanguageContainer = connect(mapStateToProps, mapDispatchToProps)(CurrencyTaxLanguagePage);



// WEBPACK FOOTER //
// ./src/js/containers/settings/currency-tax-language-container.jsx